import * as React from "react";
import { CalendarState, DateMetaData, ExtraPage, SpiralItem } from "burde";
import * as styles from "./extra-pages.css";
import { connect } from "react-redux";
import { actionCreators } from "page/calendar/store";
import { ApplicationState } from "store";
import { actionCreators as uiActionCreators } from "ui/store";
import { getDualPagePreviewContainer } from "svg/draw/helpers/preview-helper";
import drawDynamicExtraPage from "../../../../svg/draw/draw-dynamic-extra-page";
import * as cn from "classnames/bind";
import moment from "moment";
import { useResources } from "contexts/resource-context";
import { CalendarDimensions } from "svg/constants";

const cx = cn.bind(styles);

type Props = {
    calendar: CalendarState;
    previewedExtraPage: ExtraPage;
    spiral: SpiralItem | null;
    metadata: DateMetaData[];
};

const ExtraPages = ({
    calendar,
    previewedExtraPage,
    spiral,
    metadata,
}: Props) => {
    const calendarDimensions = CalendarDimensions.find(
        (x) => x.calendarSize === calendar.calendarSize,
    );

    const resources = useResources();

    if (calendarDimensions === undefined) return <></>;

    const drawPreviewedExtraPage = async (ref: HTMLDivElement | null) => {
        let dualPageSvgs = getDualPagePreviewContainer(ref, calendar, spiral);
        if (!dualPageSvgs || previewedExtraPage === null) return;

        // Left page
        const leftPageSvg = previewedExtraPage.endpoints.leftPage;

        dualPageSvgs.leftSvg
            .append("g")
            .attr("transform", `translate(-30, -30)`)
            .html(leftPageSvg !== undefined ? leftPageSvg : "");

        dualPageSvgs.leftSvg
            .select(".outerContent")
            .attr("height", calendarDimensions.contentHeightWithoutBleeds + 60)
            .attr("width", calendarDimensions.contentWidthWithoutBleeds + 60);

        // Right page
        const rightPageSvg = previewedExtraPage.endpoints.rightPage;

        dualPageSvgs.rightSvg
            .append("g")
            .attr("transform", `translate(-30, -30)`)
            .html(rightPageSvg !== undefined ? rightPageSvg : "");

        dualPageSvgs.rightSvg
            .select(".outerContent")
            .attr("height", calendarDimensions.contentHeightWithoutBleeds + 60)
            .attr("width", calendarDimensions.contentWidthWithoutBleeds + 60);

        if (previewedExtraPage.dynamicDates === true) {
            drawDynamicExtraPage(
                dualPageSvgs.leftSvg,
                moment(calendar.startDate),
                metadata,
                calendar.culture,
                resources["Header_WeekNumberPrefix"],
            );

            drawDynamicExtraPage(
                dualPageSvgs.rightSvg,
                moment(calendar.startDate),
                metadata,
                calendar.culture,
                resources["Header_WeekNumberPrefix"],
            );
        }
    };

    const svgContainerCn = () =>
        cx({
            svgContainer: true,
            "svg-container": true,
        });

    const calendarContainerCn = () =>
        cx({
            calendarContainer: true,
        });

    return (
        <div key={"previewed-extra-page"} className={calendarContainerCn()}>
            <div
                className={svgContainerCn()}
                ref={(ref) => drawPreviewedExtraPage(ref)}
            />
        </div>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    calendar: state.calendar,
    previewedExtraPage: state.ui.PreviewedExtraPage,
    metadata: state.burdeApiContent.metadata,
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtraPages);
